export default __webpack_public_path__ + "static/media/scale02.55c65305.svg";